// extracted by mini-css-extract-plugin
module.exports = {"button":"table-button-m__button__2Z-H3","selected":"table-button-m__selected__OMgD1"};